import { useCallback, useRef, useState } from "react";

const useClientRect = () => {
  const [rect, setRect] = useState<DOMRect | null>(null);
  const observerRef = useRef<ResizeObserver | null>(null);

  const getObserver = () => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- doesnt exist in test
    if (window.ResizeObserver && observerRef.current === null) {
      observerRef.current = new ResizeObserver(([entry]) => {
        setRect(entry ? entry.target.getBoundingClientRect() : null);
      });
    }

    return observerRef.current;
  };

  const elementRef = useCallback((element: Element | null) => {
    const observer = getObserver();

    if (observer) {
      observer.disconnect();
    }

    if (element !== null) {
      if (observer) {
        observer.observe(element);
      } else {
        setRect(element.getBoundingClientRect());
      }
    } else {
      setRect(null);
    }
  }, []);

  return [rect, elementRef] as const;
};

export default useClientRect;
